import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultType } from "../../types.client";
import { BatteryVoltageMeasure } from "../../../models/schemas/measures/electrical.schema";
import { BATTERY_VOLTAGE_THRESHOLDS } from "../../constants/judgmentCriteria";

/**
 * 배터리 전압 컨트롤러
 * 판정 기준: |배터리전압 - 정격전압| <= BATTERY_VOLTAGE_THRESHOLDS.tolerance (±2V 이내)
 */
export class BatteryVoltageController extends MeasureController<BatteryVoltageMeasure> {
  protected getDefaultData(): BatteryVoltageMeasure {
    return {
      ratedVoltage: 0,
      batteryVoltage: 0,
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
    };
  }

  protected judge(): JudgmentResult {
    const { batteryVoltage, ratedVoltage } = this.data;

    // 데이터 미입력 시
    if (!batteryVoltage || !ratedVoltage) {
      return {
        result: "NA",
        discussion: this.generateDiscussion("NA"),
      };
    }

    // ±tolerance 범위 체크
    const deviation = Math.abs(batteryVoltage - ratedVoltage);
    const result: JudgmentResultType =
      deviation <= BATTERY_VOLTAGE_THRESHOLDS.tolerance ? "GOOD" : "BAD";

    return {
      result,
      discussion: this.generateDiscussion(result),
    };
  }

  protected generateDiscussion(result: JudgmentResultType): string {
    const { batteryVoltage, ratedVoltage } = this.data;

    if (result === "NA") {
      return "데이터 미입력";
    }
    if (result === "GOOD") {
      return `배터리전압(${batteryVoltage}V)이 정격전압(${ratedVoltage}V) 대비 ±2V 이내로 정상`;
    }
    return `배터리전압(${batteryVoltage}V)이 정격전압(${ratedVoltage}V) 대비 ±2V 범위를 벗어남. 점검 필요`;
  }
}
